import React, { useState } from 'react';
import { Container, Header, ExpandButton, IconContainer } from '../../Tabs.styles';
import CustomTitle from '../../../CustomTitle/index';
import { AllLinksContainer } from './CollapsibleLinks.styles';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import LinkItem from '../LinkItem';
import { hexToRgba } from '../../../../../utils/helpers';
import EmptyContent from '../../../EmptyContent';

const CollapsibleLinks = ({ links = [], icon, title, segmentColor }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  if (links.length === 0) {
    return <EmptyContent />;
  }

  // Number of links to display
  const visibleLinks = isExpanded ? links : links.slice(0, 3);

  return (
    <Container>
      <Header>
        <IconContainer bgColor={segmentColor}>
          {/* <FaChevronDown />  Dummy icon for now */}
        </IconContainer>
        <CustomTitle title={title} count={links.length} />
        <ExpandButton showIcon={links.length > 3} onClick={toggleExpand}>
          {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
        </ExpandButton>
      </Header>

      <AllLinksContainer
        bgColor={hexToRgba(segmentColor, 0.5)}
        isExpanded={isExpanded}
        linksLength={links.length}
      >
        {visibleLinks.map((e, index) => (
          <LinkItem link={e} key={index} />
        ))}
      </AllLinksContainer>
    </Container>
  );
};

export default CollapsibleLinks;
